module.exports = __webpack_public_path__ + "img/Twix.0b848f7e.webp";